var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Watch } from "vue-facing-decorator";
import { SitesClient, CompaniesClient, CountriesClient, RegionsClient, ContactGroupClient, TimeZonesClient, SiteModel, AddressModel, CreateSiteCommand, GetContactGroupListQuery, UpdateSiteCommand } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { TextHelper } from "@/app/utils/text-helper";
import { ArrayHelper } from "@/app/utils/array-helper";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const siteClient = new SitesClient(window.apiUrl);
const companyClient = new CompaniesClient(window.apiUrl);
const countryClient = new CountriesClient(window.apiUrl);
const regionClient = new RegionsClient(window.apiUrl);
const contactGroupsClient = new ContactGroupClient(window.apiUrl);
const timeZonesClient = new TimeZonesClient(window.apiUrl);
let SiteVue = class SiteVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.siteId = 0;
        this.loaded = false;
        this.working = false;
        this.attemptedSave = false;
        // models
        this.site = new SiteModel();
        // arrays
        this.companies = [];
        this.countries = [];
        this.regions = [];
        this.contactGroups = [];
        this.timeZones = [];
    }
    created() {
        this.siteId = parseInt(this.$route.params.id) || 0;
        this.get();
        this.getLookups();
    }
    ;
    mounted() {
    }
    ;
    // get
    get() {
        if (!this.siteId || this.siteId <= 0) {
            let site = new SiteModel();
            site.init({});
            this.map(site);
            return;
        }
        ;
        siteClient
            .get(this.siteId)
            .then(response => {
            var _a, _b;
            this.map(response);
            this.setValues({
                companyId: this.company,
                siteName: this.site.siteName,
                email: ((_a = this.site.address) === null || _a === void 0 ? void 0 : _a.emailAddress) || undefined,
                phone: ((_b = this.site.address) === null || _b === void 0 ? void 0 : _b.phone) || undefined,
            });
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    getLookups() {
        let promises = [
            countryClient
                .getList()
                .then((response) => {
                this.countries = (response || []).map((item) => {
                    return {
                        value: item.countryId,
                        text: item.countryName || ""
                    };
                });
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }),
            regionClient
                .getList()
                .then((response) => {
                this.regions = (response || []).map((item) => {
                    return {
                        value: item.regionId,
                        text: item.regionName || "",
                        parentKey: item.countryId
                    };
                });
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }),
            companyClient
                .getListGET()
                .then(response => {
                this.companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || ""
                    };
                });
                if (this.site.companyId) {
                    this.setFieldValue("companyId", this.company);
                }
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                let companyId = parseInt(this.$route.params.companyId) || 0;
                if (!companyId || !this.isNewSite)
                    return;
                let idx = ArrayHelper.findFirstIndex(this.companies, (item) => {
                    return companyId == item.value;
                });
                if (idx < 0)
                    return;
                this.site.companyId = companyId;
                this.setFieldValue("companyId", this.company);
            }),
            timeZonesClient
                .getList()
                .then(response => {
                this.timeZones = (response || []).map((item) => {
                    return {
                        value: item.id,
                        text: item.displayName || item.id || ""
                    };
                });
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
        ];
        Promise.all(promises);
    }
    ;
    getContactGroups() {
        contactGroupsClient
            .getListPOST(new GetContactGroupListQuery({ companyId: this.companyId, includeDeleted: false, keywords: "" }))
            .then(response => {
            this.contactGroups = (response || []).map((item) => {
                return {
                    value: item.contactGroupId,
                    text: item.description || ""
                };
            });
            if (this.site.contactGroupId && !this.contactGroups.map(item => item.value).includes(this.site.contactGroupId)) {
                this.site.contactGroupId = null;
            }
        });
    }
    ;
    map(site) {
        this.site = site;
        let address = this.site.address;
        if (!address) {
            address = new AddressModel();
            address.init({});
            this.site.address = address;
        }
        ;
        this.loaded = true;
    }
    ;
    onCompanyIdChanged() {
        this.getContactGroups();
    }
    ;
    // set
    // set
    save() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (this.working)
            return;
        if (((_b = (_a = this.site.address) === null || _a === void 0 ? void 0 : _a.latitude) !== null && _b !== void 0 ? _b : 0) < -90) {
            Notifier.onWarning(`Latitude cannot be lower than -90`);
            return;
        }
        if (((_d = (_c = this.site.address) === null || _c === void 0 ? void 0 : _c.latitude) !== null && _d !== void 0 ? _d : 0) > 90) {
            Notifier.onWarning(`Latitude cannot be greater than 90`);
            return;
        }
        if (((_f = (_e = this.site.address) === null || _e === void 0 ? void 0 : _e.longitude) !== null && _f !== void 0 ? _f : 0) < -180) {
            Notifier.onWarning(`Longitude cannot be lower than -180`);
            return;
        }
        if (((_h = (_g = this.site.address) === null || _g === void 0 ? void 0 : _g.longitude) !== null && _h !== void 0 ? _h : 0) > 180) {
            Notifier.onWarning(`Longitude cannot be greater than 180`);
            return;
        }
        const handleSubmitAction = this.handleSubmit(() => {
            let site = this.site;
            let promise = () => {
                return this.isNewSite
                    ? siteClient.add(new CreateSiteCommand({ requestModel: site }))
                    : siteClient.update(site.siteId, new UpdateSiteCommand({ requestModel: site }));
            };
            this.working = true;
            promise()
                .then(response => {
                this.siteId = response;
                this.get();
                Notifier.onOk();
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        }, () => {
            Notifier.onError("Please check that you have entered all details correctly.");
        });
        handleSubmitAction();
    }
    ;
    archive() {
        if (this.working)
            return;
        siteClient
            .getArchiveImpact(this.site.siteId)
            .then((impact) => {
            const parts = [];
            if (impact.systemsCount > 0) {
                parts.push(`${impact.systemsCount} system${impact.systemsCount === 1 ? '' : 's'}`);
            }
            let msg;
            if (parts.length > 0) {
                let subjects = '';
                if (parts.length === 1) {
                    subjects = parts[0];
                }
                else if (parts.length === 2) {
                    subjects = `${parts[0]} and ${parts[1]}`;
                }
                else {
                    subjects = `${parts.slice(0, -1).join(', ')}, and ${parts[parts.length - 1]}`;
                }
                msg = `Archiving this site will also archive ${subjects}. Are you sure you want to continue?`;
            }
            else {
                msg = "Are you sure that you want to archive this site?";
            }
            this.$confirmModal.show(msg, { title: "Please confirm" })
                .then((value) => {
                if (!value)
                    return;
                this.performArchive();
            });
        });
    }
    performArchive() {
        console.log('performArchive 1');
        this.working = true;
        siteClient
            .delete(this.site.siteId)
            .then(() => {
            this.site.whenDeleted = new Date();
            Notifier.onOk();
            console.log('performArchive Ok');
        })
            .catch((ex) => {
            console.log('performArchive 2');
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            console.log('performArchive 3');
        });
    }
    restore() {
        if (this.working || this.isNewSite)
            return;
        this.working = true;
        siteClient
            .restore(this.site.siteId)
            .then(() => {
            this.site.whenDeleted = undefined;
            Notifier.onOk(`Site # ${this.site.siteId} has been successfully restored.`);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    goBack() {
        this.$router.back();
    }
    ;
    // computed
    get pageTitle() {
        return this.isNewSite ? "New Site" : this.siteTitle;
    }
    ;
    get siteTitle() {
        if (!this.site)
            return "";
        return TextHelper.getRecordTitle(this.site.siteName || "", this.isSiteArchived);
    }
    ;
    get isNewSite() {
        return !this.siteId;
    }
    ;
    get isSiteArchived() {
        return this.site.whenDeleted != null;
    }
    ;
    get hasAddress() {
        return this.site && this.site.address ? true : false;
    }
    ;
    get companyId() {
        return this.site.companyId;
    }
    ;
    get company() {
        return this.companies.filter(item => {
            return (item.value == this.site.companyId);
        })[0] || null;
    }
    ;
    set company(item) {
        if (!item)
            return;
        this.site.companyId = item.value;
    }
    ;
    get countryId() {
        if (!this.site.address)
            return null;
        return this.site.address.countryId;
    }
    ;
    get country() {
        return this.countries.filter(item => {
            return item.value == this.countryId;
        })[0] || null;
    }
    ;
    set country(item) {
        var _a;
        if (!this.site.address)
            return;
        this.site.address.countryId = (_a = item === null || item === void 0 ? void 0 : item.value) !== null && _a !== void 0 ? _a : null;
    }
    ;
    get regionId() {
        if (!this.site.address)
            return null;
        return this.site.address.regionId;
    }
    ;
    get region() {
        return this.regions.filter(item => {
            return item.value == this.regionId;
        })[0] || null;
    }
    ;
    set region(item) {
        var _a;
        if (!this.site.address)
            return;
        this.site.address.regionId = (_a = item === null || item === void 0 ? void 0 : item.value) !== null && _a !== void 0 ? _a : null;
    }
    ;
    get contactGroup() {
        console.log(this.site);
        return this.contactGroups.filter(item => {
            return item.value == this.site.contactGroupId;
        })[0] || null;
    }
    ;
    set contactGroup(item) {
        var _a;
        this.site.contactGroupId = (_a = item === null || item === void 0 ? void 0 : item.value) !== null && _a !== void 0 ? _a : null;
    }
    ;
    get timeZone() {
        return this.timeZones.filter(item => {
            return item.value == this.site.timeZoneId;
        })[0] || null;
    }
    ;
    set timeZone(item) {
        this.site.timeZoneId = item ? item.value : null;
    }
    ;
    get selectPlaceholder() {
        return TextHelper.emptyListItemName;
    }
    ;
};
__decorate([
    Watch("companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SiteVue.prototype, "onCompanyIdChanged", null);
SiteVue = __decorate([
    Component({
        name: "SiteVue",
        setup() {
            let phoneRegExp = new RegExp("^(?=.*[0-9])[- +()0-9]+$");
            const { errors, handleSubmit, defineInputBinds, defineComponentBinds, setFieldValue, setValues } = useForm({
                validationSchema: yup.object({
                    companyId: yup.object().listOptionRequired(),
                    siteName: yup.string().trim().required(),
                    email: yup.string().email(),
                    phone: yup.string().min(9).matches(phoneRegExp),
                }),
            });
            const companyIdVal = defineComponentBinds('companyId');
            const siteNameVal = defineInputBinds('siteName');
            const emailVal = defineInputBinds('email');
            const phoneVal = defineInputBinds('phone');
            return {
                errors,
                handleSubmit,
                setFieldValue,
                setValues,
                companyIdVal,
                siteNameVal,
                emailVal,
                phoneVal,
            };
        }
    })
], SiteVue);
export default SiteVue;
